// Shared attachment validation/type helpers, used by both Account and
// Transaction attachment UI (AddEditAccountBottomSheet, AddTransaction,
// TransactionForm) so the allow-list & size limit stay consistent with the
// backend (see server/app/middleware/attachmentUploadMiddleware.js).

export const ALLOWED_ATTACHMENT_MIME_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
    'application/pdf',
    'text/plain',
];

export const ALLOWED_ATTACHMENT_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.pdf', '.txt'];

// `accept` attribute for <input type="file">
export const ATTACHMENT_ACCEPT = [
    ...ALLOWED_ATTACHMENT_MIME_TYPES,
    ...ALLOWED_ATTACHMENT_EXTENSIONS,
].join(',');

export const MAX_ATTACHMENT_SIZE_BYTES = 4 * 1024 * 1024; // 4 MB

// Previewable image extensions supported by current attachment policy.
const PREVIEWABLE_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp'];

export const getFileExtension = (filenameOrFile) => {
    const name = typeof filenameOrFile === 'string' ? filenameOrFile : filenameOrFile?.name || '';
    const idx = name.lastIndexOf('.');
    return idx >= 0 ? name.slice(idx).toLowerCase() : '';
};

export const isPreviewableImage = (filenameOrFile) => {
    return PREVIEWABLE_IMAGE_EXTENSIONS.includes(getFileExtension(filenameOrFile));
};

/**
 * Validates a File object against the shared attachment rules.
 * @returns {string|null} translated error message, or null if valid.
 */
export const validateAttachmentFile = (file, t) => {
    if (!file) return null;

    const ext = getFileExtension(file);
    const mimeOk = ALLOWED_ATTACHMENT_MIME_TYPES.includes(file.type);
    const extOk = ALLOWED_ATTACHMENT_EXTENSIONS.includes(ext);

    if (!mimeOk && !extOk) {
        return t('onlyAttachmentTypesAllowed');
    }
    if (file.size > MAX_ATTACHMENT_SIZE_BYTES) {
        return t('fileSizeLessThan4MB');
    }
    return null;
};
